import type { Ref, ComputedRef } from 'vue-demi';

import { invoke } from '@yoda/bridge';
import { injectVisibility } from '@pet/base.utils';
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue-demi';

export function useCountDown(endTime: Ref<number> | ComputedRef<number>) {
    const lastTime = ref(endTime.value - Date.now());
    const useVisibility = injectVisibility();

    let timer = 0;
    let timeDiff = 0;

    // 后面对于ServerTime这个东西，可能得抽出去搞一下……
    async function changeTimeDiff() {
        try {
            const { serverTimeStamp: currentTime } = await invoke('system.getServerTime');
            timeDiff = currentTime - Date.now();
        } catch (e) {
            timeDiff = 0;
        }
        lastTime.value = endTime.value - Date.now() - timeDiff;
    }

    function startInterval() {
        const start = Date.now();
        return window.setTimeout(() => {
            const end = Date.now();
            lastTime.value = lastTime.value - end + start;
            // 后续这里可以根据倒计时来调整间隔
            startInterval();
        }, 1000);
    }

    watch(
        () => endTime.value,
        async () => {
            await changeTimeDiff();
        },
    );

    useVisibility?.useVisibilityChange(async (show) => {
        if (show) {
            await changeTimeDiff();
        }
    });

    onMounted(() => {
        changeTimeDiff();
        timer = startInterval();
    });

    onBeforeUnmount(() => {
        clearTimeout(timer);
    });

    return lastTime;
}

const DAY = 1000 * 60 * 60 * 24;
const HOUR = 1000 * 60 * 60;
const MINUTE = 1000 * 60;
const SECOND = 1000;

export function useCountDownInfo(endTime: ComputedRef<number>) {
    const lastTime = useCountDown(endTime);

    const day = computed(() => (lastTime.value < 1 ? 0 : Math.floor(lastTime.value / DAY)));
    const hour = computed(() => (lastTime.value < 1 ? 0 : Math.floor((lastTime.value % DAY) / HOUR)));
    const minute = computed(() => (lastTime.value < 1 ? 0 : Math.floor((lastTime.value % HOUR) / MINUTE)));
    const second = computed(() => (lastTime.value < 1 ? 0 : Math.floor((lastTime.value % MINUTE) / SECOND)));
    return {
        day,
        hour,
        minute,
        second,
    };
}
